import spending from "../../assets/spending.webp"
import stingy from "../../assets/stingy.webp"
import { environment } from "../functions"
import { BLUE, RED } from "./colors"

export const BLANK = ""
export const BLANK_PAYLOAD = {
    name: BLANK,
    value: 0
}
export const LOGIN_PAYLOAD = {
    username: BLANK,
    password: BLANK
}
export const BLANK_ARR = []
export const EXCEL_URL = environment("BACKEND_URL")

export const EXCEL_HEADERS = { responseType: 'blob' }

export const INCOME_SAMPLES = [
    "Salary",
    "Stocks",
    "Royalty",
    "Gov't Check",
    "Gift",
    "Crypto",
    "Bitcoin",
    "Ethereum"
]
export const EXPENSE_SAMPLES = [
    "Rent",
    "Food",
    "Gas",
    "Electricity",
    "Utilities",
    "Phone",
    "Student Loans",
    "Car Loans",
    "Credit Card",
    "Toll",
    "Gym"
]

const links = [
    "dQw4w9WgXcQ",
    "D8QykNHjSgM",
    "wGkmxHEuI7w",
    "5JhQG2u8Ow8",
    "T3rXdeOvhNE",
    "eZ2PtEx9-ls",
    "d4Pba9jKoJU",
    "5xxQs34UMx4",
    "EW1kt5kOJQ8"
]
const getRandomIndex = () => floor(random() * links.length);
const randomLink = () => links[getRandomIndex()]

const {floor, random} = Math

export const ABOUT_CARD = [
    {
        img: stingy,
        title: "Do you fear debt?",
        link: "/budget",
        button: "Start budgeting",
        color: BLUE
    },
    {
        img: spending,
        title: "Do you not fear debt?",
        link: "https://www.youtube.com/watch?v="+randomLink(),
        button: "I'll take my chances",
        color: RED
    }
]
